"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmptyHistory = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        textAlign: 'center',
        border: "1px solid ".concat(theme.palette.grey[200]),
        borderRadius: theme.spacing(2),
        padding: theme.spacing(6, 2)
    };
});
const IconWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    margin: '0 auto',
    maxWidth: 190,
    justifyContent: 'space-around'
});
const EmptyHistoryMessage = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        display: 'block',
        margin: '0 auto',
        maxWidth: 190,
        paddingTop: theme.spacing(4),
        fontWeight: 'bold',
        color: theme.palette.grey[400]
    };
});
const HomeIcon = (0, _mui.styled)(_icons.Home)((param)=>{
    let { theme } = param;
    return {
        fontSize: '2.8rem',
        color: theme.palette.default.light
    };
});
const PickupIcon = (0, _mui.styled)(_icons.Pickup)((param)=>{
    let { theme } = param;
    return {
        fontSize: '2.8rem',
        color: theme.palette.default.light
    };
});
const BoxIcon = (0, _mui.styled)(_icons.Box)((param)=>{
    let { theme } = param;
    return {
        fontSize: '2.8rem',
        color: theme.palette.default.light
    };
});
const EmptyHistory = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ...getTestIdProps(_models.TestId.EmptyHistory),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IconWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.IconCircle, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HomeIcon, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.IconCircle, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickupIcon, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.IconCircle, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyHistoryMessage, {
                variant: "subtitle1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "yourPreviousDeliveriesWillAppearHere"
                })
            })
        ]
    });
};
exports.EmptyHistory = EmptyHistory;
